import React from 'react';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import AggregationBuilder from 'src/components/BeaconV2Components/utils/AggregationBuilder';

const aggregationBuilder = (aggBuilder: AggregationBuilder): AggregationBuilder => {
  return aggBuilder.clearConditionRangeFilters().addConditionRangeFilter('organicClicks', 1);
};
export default function ProductsWithOrganicTrafficSplineChart() {
  return (
    <BeaconComparableSplineChart
      title="Products with Organic Traffic"
      indexName="traffic"
      fieldName="stacklineSku"
      primaryAggregationBuilder={aggregationBuilder}
      secondaryAggregationBuilder={aggregationBuilder}
    />
  );
}
